export enum InboundLoadStatus {
    Planned = 1,
    Arrived = 2,
    Unloaded = 4,
    Processed = 3
}
